export const HELP_URL = "https://fokused.me/s/home/wiki/overview/list-categories";
 